<template>
  <span class="city-selector">
    <df-nav-item v-if="dropDown">{{ cityName }}</df-nav-item>
    <df-nav-item v-else @click.stop="onToggleCity">
      <span>{{ cityName }}</span>
      <i class="df-arrow" :class="flag ? 'df-arrow_active' : ''"></i>
    </df-nav-item>
    <def-city
        v-show="flag"
        :allCities="allCities"
        :hotCities="hotCities"
        :top="position.top"
        :right="position.right"
        @onHideCity="onHideCity"
    />
  </span>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "CitySelector",
  components: {
    DefCity: () => import("../DefCity"),
  },
  data() {
    return {
      cityName:
          (Cookies.get("address") &&
              JSON.parse(Cookies.get("address") || "{}").cityName) ||
          this.TLang("上海", "my"),
      flag: false,
      dropDown: false,
      allCities: [],
      hotCities: [],
      df_lang: Cookies.get("df_lang"),
      position: {
        top: '28px',
        right: '0px',
      },
    };
  },
  watch: {
    $route(newVal, oldVal) {
      const arr = ["packageDetails", "OrganDetails"];
      if (oldVal.query.city && oldVal.query.city !== newVal.query.city) {
        this.getCityData();
      }

      this.dropDown = arr.includes(newVal.name);
    },
  },
  created() {
    // 获取城市数据
    this.getCityData();
  },
  mounted() {
    document.addEventListener("click", this.onHideCity);
    this.$bus.$on("changeCity", this.onToggleCity);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onHideCity);
    this.$bus.$off("changeCity", this.onToggleCity);
  },
  methods: {
    getCityData() {
      // this.apis.headerApi.getCityData().then((res) => {
      //   this.allCities = res.cityList;
      //   this.hotCities = res.hotCities;
      //   if (
      //       (this.df_lang && this.df_lang == "en-US") ||
      //       window.union_isBilingual
      //   ) {
      //     this.getCityPinyin();
      //   }
      // });
      this.apis.newBfdHeaderApi.getCityData().then((res) => {
        // console.log('新百福得接口数据', res.data);
        this.allCities = res.data.cityList;
        this.hotCities = res.data.hotCities;
        if (
          (this.df_lang && this.df_lang == "en-US") ||
            window.union_isBilingual
        ) {
          this.getCityPinyin();
        }
      });
    },
    getCityPinyin() {
      if (this.allCities && this.allCities.length > 0) {
        this.allCities.forEach((i) => {
          if (i.name == this.cityName) {
            this.cityName = i.pinyin;
          }
        });
      }
    },
    onToggleCity() {
      this.flag = !this.flag;
      if(this.flag) {
        const {bottom, right} = this.$el.getBoundingClientRect();
        this.position.top = bottom + 'px';
        this.position.right = 0;
      }
    },
    onHideCity() {
      this.flag = false;
    },
  },
};
</script>

<style lang="less" scoped>
.city-selector {
  cursor: pointer;
}
</style>
